import React from "react";
import {Route, Switch} from "react-router-dom";
import SubscriptionPlans from "./subscriptionPlan"


const App = ({match}) => (
    <Switch>
      <Route exact path={`${match.url}`} component={SubscriptionPlans}/>
    </Switch>
);

export default App;
